import { useDataProvider } from 'react-admin';
import useGetTokenFromLocalStorage from '@/hooks/use-get-token-from-local-storage';
import { useQuery } from '@tanstack/react-query';
import { METABASE_VIEWS_VIEWS_DYNAMIC } from '@/utils/CONST';
import { useMemo } from 'react';
import axios from 'axios';

interface Props {
    metadata_avatar_type__alphaId: string;
    node_name: string;
    avatar_root_id: string;
    avatar_left: number;
    avatar_right: number;
    avatar_level: number;
}

const useGetDashboardCounterFormatQuestion175 = (props: Props) => {
    const dataProvider = useDataProvider();
    const getTokenFromLocalStorage: any = useGetTokenFromLocalStorage();

    const { data, isLoading } = useQuery({
        queryKey: ['dashboardCounterFormatQuestion175', props],
        queryFn: () => {
            return dataProvider
                .create(METABASE_VIEWS_VIEWS_DYNAMIC, {
                    data: {
                        dashboard_type: 'question',
                        id: 175,
                        token: getTokenFromLocalStorage(),
                        metadata_avatar_type__alphaId: props.metadata_avatar_type__alphaId,
                        node_name: props.node_name,
                        avatar_root_id: props.avatar_root_id,
                        avatar_left: props.avatar_left,
                        avatar_right: props.avatar_right,
                        avatar_level: props.avatar_level,
                    },
                    meta: {
                        basePath: 'dashboard',
                    },
                })
                .then(({ data: { get_response_forwarder_to_metabase_api } }: any) =>
                    axios.get(get_response_forwarder_to_metabase_api).then(
                        ({
                            data: {
                                data: { rows },
                            },
                        }: any) => rows,
                    ),
                );
        },
        enabled: true,
    });

    const value = useMemo(() => {
        if (!data) {
            return 0;
        }

        return data[0][0];
    }, [data]);

    return {
        value,
        isLoading,
    };
};

export default useGetDashboardCounterFormatQuestion175;
